<template>
  <div class="flex gap-4 flex-col-reverse md:flex-row md:w-full md:justify-start">
    <div
      v-if="imageList.length > 0"
      class="h-16 w-full md:w-28 overflow-x-auto md:overflow-x-hidden md:overflow-y-auto flex flex-row justify-evenly gap-2 md:gap-4 md:h-[500px] lg:h-[400px] xl:h-[600px] md:min-w-28 md:flex-col md:items-center md:justify-start"
    >
      <img
        v-for="[i, image] in imageList.entries()"
        :key="image.uuid"
        class="flex-shrink-0 w-16 h-16 md:h-28 md:w-28 object-cover border border-custom-100"
        :src="image.original_url"
        @click="imageIndex = i"
      >
      <div
        v-if="imageList.length === 0"
        class="bg-gray-300"
      />
    </div>
    <div
      v-if="imageList.length > 0"
      class="flex items-center justify-center w-full bg-black bg-opacity-5"
    >
      <img
        :src="imageList[imageIndex].original_url"
        class="w-full object-center object-contain h-[400px] md:h-[500px] lg:h-[400px] xl:h-[600px]"
      >
    </div>
    <div
      v-else
      class="bg-custom-100 w-full italic md:w-auto md:h-[500px] lg:h-[400px] xl:h-[600px] xl:w-full flex font-semibold items-center justify-center"
    >
      <p>
        Libro sin imagenes
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageIndex: 0,
      imageList: Object.values(this.images),
    };
  },
};
</script>
